import ScreenICon from '../Modules/ScreenICon/ScreenICon';
import Auth from '../Services/Auth/AuthService';
import LoginForm from '../Modules/LoginForm/LoginForm';

export const PrivateRoute = () => {
  return Auth._Authenticated ? <ScreenICon /> : <LoginForm />;
};
